import { useService } from 'react-reservice';

import paymentService from './service';

export const usePayment = () => {
  return useService(paymentService, (state) => state);
};

export { paymentService };
